
import { Menu } from 'primereact/menu';
import { useTranslation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import React, { useRef, Fragment, useState } from 'react';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import * as proyectAction from "../../store/actions/proyectAction";
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';
import '../../index.css';

const PopUpMenu = (global,{handleChangeLanguage,accion,refreshPanel},props) => {
    const menu = useRef(null);
    const { t } = useTranslation();
    const toast = useRef(null);
    const [visible, setVisible] = useState(false);

    const accept = () => {
        toast.current.show({ severity: 'info', summary: t('Confirmed'), detail: t('You have accepted'), life: 3000 });
        global.accion()
    }

    const reject = () => {
        toast.current.show({ severity: 'info', summary: t('Rejected'), detail: t('You have rejected'), life: 3000 });
    }

    let item=()=>([
        {
            label:  <i className="pi pi-calendar">
                        <span className="roboto marginRight10px"><span className=" roboto marginLeft10px">{t("periodo")}</span></span>
                        <select onChange={(e)=>global.handleRefreshCantDias(e)} value={global.cantDiasValue} >
                        <option value="1">
                            {'1 '+t("día")}
                        </option>
                        <option value="2">
                            {'1 '+t("semana")}
                        </option>
                        <option value="3">
                            {'1 '+t("mes")}
                        </option>
                        <option value="4">
                            {'3 '+t("meses")}
                        </option>
                        <option value="5">
                            {'6 '+t("meses")}
                        </option>
                        <option value="6">
                            {'1 '+t("año")}
                        </option>
                        </select>
                    </i>,        
            items: [ ]
        },
        {
            label:  <i className="pi pi-fw pi-globe"><span className=" roboto marginLeft10px">{t("Idioma")}</span></i>,            
            items: [ {
                label: 
                    <div>
                        <img src="assets/layout/images/EspFlag2.png" alt="" style={{width:"35px"}}/>
                        <span className="roboto marginLeft10px">{t("Español")}</span>
                    </div>,
                command: ()=>{global.handleChangeLanguage("es")},
            },
            {
                label: 
                    <div>
                        <img src="assets/layout/images/UKFlag2.png" alt="" style={{width:"35px"}}/> 
                        <span className=" roboto marginLeft10px">{t("Ingles")}</span>
                    </div>,
                command: ()=>{global.handleChangeLanguage("en")},
            },
            {
                label:
                    <div>
                        <img src="assets/layout/images/PortugalFlag.png" alt="" style={{width:"35px"}}/> 
                        <span className=" roboto marginLeft10px">{t("Portugues")}</span>
                    </div> ,
                command: ()=>{global.handleChangeLanguage("por")},
            },
            {
                label: 
                    <div>
                        <img src="assets/layout/images/FranceFlag.png" alt="" style={{width:"35px"}}/>
                        <span className=" roboto marginLeft10px">{t("Frances")}</span>
                    </div>,
                command: ()=>{global.handleChangeLanguage("fre")},
            }
        ]
        },
        {
            items: [{label: <i className="pi pi-refresh"><span className=" roboto marginLeft10px">{t("Resetear")}</span></i>,command:()=>{setVisible(true) }}]
        },        
        {
            items: [{label:  <i className="pi pi-replay"><span className=" roboto marginLeft10px">{t("Actualizar")}</span></i>,command:()=>{global.refreshPanel() }}]
        }
    ])
    return (
        <div className={"floatLeft"}>  
            <button className="p-link layout-profile-link" onClick={(event) => menu.current.toggle(event)}>
                <i className="pi pi-fw pi-cog"/>
            </button>
            <div>
            <Fragment>
                <Toast ref={toast} />
                <ConfirmDialog visible={visible} 
                    onHide={() => setVisible(false)} 
                    message={t("Are you sure you want to proceed?")}
                    header={t("Confirmation")} 
                    icon="pi pi-exclamation-triangle" 
                    acceptLabel={t("Si")}
                    rejectLabel={t("No")}
                    accept={()=>accept()} 
                    reject={()=>reject()} />
            </Fragment>
                <Menu model={item()} popup ref={menu} id="popup_menu" className={"floatLeft top50"}/>
            </div>
        </div>
    );
}
const mapStateToProps = (rootReducer) => {
    return {global: rootReducer.proyect};
};
export default connect(mapStateToProps, proyectAction)(withTranslation ("translations") (PopUpMenu));